import { Check, Close } from '@mui/icons-material';
import { Card, IconButton, TextField, Typography } from '@mui/material';
import { AsyncIconButton } from 'common/components/AsyncIconButton';
import { Filler } from 'common/components/Filler';
import { FlexRow } from 'common/FlexRow';
import { SelectEditor } from 'components/editor/SelectEditor';
import { ValueEditor } from 'components/editor/ValueEditor';
import { useRoot } from 'components/RootProvider';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { AssetCreationJob } from 'stores/creation/CreationJob';
import { StructureCreationJob } from 'stores/creation/StructureBulkJob';

type JobPreviewProps = { job: StructureCreationJob };
export const StructureJobPreview = observer((props: JobPreviewProps) => {
  const { job } = props;

  const root = useRoot();
  const store = root.structureBulk;
  const status = job.status;

  return (
    <Card sx={{ mt: 1, mb: 1 }}>
      <FlexRow sx={{ mt: 2, mb: 2, pl: 2, pr: 2 }}>
        {status === 'finished' && <Typography sx={{ mr: 1 }}>{job.structureId}</Typography>}
        <TextField value={`./${job.folder}/`} label={'folder'} disabled size='small' />
        <TextField value={`${job.type}`} label={'type'} disabled size='small' />
        <ValueEditor value={job.name} small />
        <ValueEditor value={job.height} small />
        <Typography>
          {`${job.numDirections} directions: [ ${[...job.directions.values()].join(', ')} ]`}
        </Typography>
        <Filler />
        {status === 'finished' && <Typography>Done!</Typography>}
        {status !== 'finished' && (
          <AsyncIconButton onClick={() => job.startJob()}>
            <Check></Check>
          </AsyncIconButton>
        )}
        {status === 'init' && (
          <IconButton onClick={() => store.deleteJob(job.key)}>
            <Close />
          </IconButton>
        )}
      </FlexRow>
    </Card>
  );
});
